export default {
  edit: "page:edit",
  create: "page:create",
  delete: "page:delete",
  view: "page:view",
};
